
export class Chat {
    id: number;
    parent_id: number;
    agent_id: number;
    reserve_agent_id: number;
    client_id: number;
    is_shared: boolean;
    created_at: any;

    setFromApiModel(apiModel: any): this {
        this.id = apiModel.id;
        this.parent_id = apiModel.parent_id;
        this.agent_id = apiModel.agent_id;
        this.reserve_agent_id = apiModel.reserve_agent_id;
        this.client_id = apiModel.client_id;
        this.is_shared = apiModel.is_shared;
        this.created_at = apiModel.created_at;
        return this;
    }
}
